import { BaseGameController } from '@/components/game/implementations/_base/_domain/controller/game-controller';
import { injectable, inject } from 'inversify';
import { GameIdentity, GameState } from '@/components/game/_domain/models';
import { IServerServiceFactory } from '@/app-modules/server-service';
import { IWinnersTrackerService } from '@/components/game/_domain/modules/winners-tracker-service';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IConfigurationService } from '@/app-modules/config';
import { IErrorService } from '@/app-modules/error';
import { BoxNumbersData, CallsData, CatchUpData } from '@/components/game/_domain';
import { DondBingoCallsData, DondBingoCatchUpData } from '../models';


@injectable()
class DondBingoGameController extends BaseGameController {
  public constructor(
    @inject(SERVICE_IDENTIFIERS.IConfigurationService) configurationService: IConfigurationService,
    @inject(SERVICE_IDENTIFIERS.IServerServiceFactory) serverServiceFactory: IServerServiceFactory,
    @inject(SERVICE_IDENTIFIERS.IWinnersTrackerService) winnersTrackerService: IWinnersTrackerService,
    @inject(SERVICE_IDENTIFIERS.IErrorService) errorService: IErrorService
  ) {
    super(configurationService, serverServiceFactory, winnersTrackerService, errorService);
  }

  public initialise(gameIdentity: GameIdentity) {
    this.game = this.getInitialGame(gameIdentity);
    this.initialiseGameServerConnection();
    this.initialiseGameRetryPolicySettings();
    this.initialiseGameServerService();
  }

  protected subscribeToGameEvents(): void {
    this.serverSubscriptionStore.push(
      this.gameServerService.subscribeCatchUp(this.handleCatchUpMessage.bind(this)),
      this.gameServerService.subscribeWinners(this.handleWinnersMessage.bind(this)),
      this.gameServerService.subscribeReset(this.handleResetMessage.bind(this)),
      this.gameServerService.subscribeCalls(this.handleCallsMessage.bind(this)),
      this.gameServerService.subscribeNextGame(this.handleNextGameMessage.bind(this)),
      this.gameServerService.subscribePrizeWinner(this.handlePrizeWinnerMessage.bind(this)),
      this.gameServerService.subscribeBoxNumbers(this.handleBoxNumbersMessages.bind(this))
    );
  }

  protected handleCatchUpMessage(payload: CatchUpData): void {
    const data = payload as DondBingoCatchUpData;
    this.game.representation.callboard.update(data.callValues);
    this.game.representation.boxNumberCallboard.catchup(data.callValues, data.revealedPrizes, data.playerBox);
    this.changeGameRepresentation({
      gameId: data.gameNo,
      numberOfPlayers: data.numberOfPlayers,
      isLinkedGame: data.isLinkedGame,
      promoType: data.promoType,
      promoMultiplier: data.promoMultiplier,
      prizeStructure: data.prizeStructure
    });

    // TODO: tidy up comparison to use strong typing - gameStage of 0 is the purchasing stage
    const newGameState = payload.gameStage === 0 ? GameState.Purchasing : GameState.InPlay;
    this.changeGameState(newGameState);
  }

  protected handleCallsMessage(payload: CallsData): void {
    const data = payload as DondBingoCallsData;
    this.game.representation.callboard.update([data.callValue], data.callNumber);
    this.game.representation.boxNumberCallboard.update(data.callValue, data.boxPrize, data.box, data.firstBox);
    this.notifyGameRepresentationChanged();
  }

  protected handleBoxNumbersMessages(payload: BoxNumbersData): void {
    this.game.representation.boxNumberCallboard.set(payload.numbers, payload.prizes);
    this.notifyGameRepresentationChanged();
  }
}

export { DondBingoGameController };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/dondbingo/_domain/controller/game-controller.ts